import React, { FC, ReactElement, useMemo } from 'react';

import { RelayEnvironmentProvider } from 'react-relay';
import {
  Environment,
  Network,
  RecordSource,
  Store,
} from 'relay-runtime';
import { useHydrateAtoms } from 'jotai/utils';
import { environmentAtom } from 'jotai-relay';

import { fetchRelay } from './environment';

//TODO: Issue With @types/relay-types
const EnvironmentProvider: any = RelayEnvironmentProvider;

export function createEnvironment(): Environment {
  const network = Network.create(fetchRelay);
  const store = new Store(new RecordSource(), {
    // This property tells Relay to not immediately clear its cache when the user
    // navigates around the app. Relay will hold onto the specified number of
    // query results, allowing the user to return to recently visited pages
    // and reusing cached data if its available/fresh.
    gcReleaseBufferSize: 10,
  });
  return new Environment({ store, network });
}

export const JotaiRelayEnvironment: FC<{
  environment: Environment;
  children: ReactElement;
}> = ({ environment, children }): React.ReactElement => {
  useHydrateAtoms([[environmentAtom, environment]]);
  return children;
};

export const RelayEnvironment: FC<{ children: ReactElement }> = ({
  children,
}): React.ReactElement => {
  const environment = useMemo(() => {
    return createEnvironment();
  }, []);

  return (
    <EnvironmentProvider environment={environment}>
      <JotaiRelayEnvironment environment={environment}>
        {children}
      </JotaiRelayEnvironment>
    </EnvironmentProvider>
  );
};
